<h1 class="text-3xl font-semibold text-gray-900">
    Create a new mission
</h1>
<app-project-create-mission-form></app-project-create-mission-form>
  